import { z } from 'zod';

export const accountTypePostRequestSchema = z.object({ value: z.string() });
